<template>
    <v-container v-resize="onResize">
        <v-layout v-if="!loading" row wrap >
            <v-flex sm6>
                <statistical-header containedInCol="true" :title="title"></statistical-header>
                <br />
            </v-flex>
            <v-flex sm3 class="pt-5 pt-xs-0">
                <count-up :endVal="totalWomenCount" text="Women Parliamentarians" />
            </v-flex>
            <v-flex sm3 class="pt-5 pt-xs-0">
                <count-up :endVal="womenInCurrentParliament" text="Women in current Parliament" />
            </v-flex>
        </v-layout>
    
        <loader v-if="loading" />
        <template v-if="!loading">
              <v-layout row wrap align-center>
                  <v-flex xs12 md12 lg12 xl2 class="pt-xs-2">
                    <statistical-member-or-senator-selector :value="selectedMpOrSenator" @input="selectedMpOrSenator = $event" />
                </v-flex>
                <v-flex xs12 md4 lg4 xl4>
                    <v-layout class="mr-5 mr-xs-0" row wrap align-center justify-space-between>
                        <v-text-field
                            v-model="search"
                            @keydown.enter="isOpen = false"
                            @keydown.esc="isOpen = false"
                            @input="debouncedOnChange"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details></v-text-field>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md4 lg4 xl3>
                    <v-autocomplete class="mr-5 mr-xs-0 pt-4" :items="PARTIES"
                  
                        :label="partySelectLabel"
                        v-model="SELECTED_PARTIES"
                        v-on:change="PERFORM_SEARCH"
                        :search-input.sync="partySearchInput"
                        auto-select-first multiple small-chips deletable-chips>
                        <template v-slot:selection="{ item, index }">
                            <v-chip @input="deletePartySelectionItem(item)" small close v-if="index == 0">{{item}}</v-chip>
                            <v-chip small v-if="index == 1">+ {{SELECTED_PARTIES.length - 1}} more</v-chip>
                        </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex xs12 md4 lg4 xl3>
                    <v-autocomplete class="pt-4" :items="this.$store.getters.GET_STATES"
                        item-text="Name" item-value="Name"
                        :label="stateSelectLabel"
                        v-model="SELECTED_STATES"
                        v-on:change="PERFORM_SEARCH"
                        :filter="FILTER_STATE_OPTIONS"
                        :search-input.sync="stateSearchInput"
                        multiple small-chips deletable-chips>
                        <template v-slot:selection="{ item, index }">
                            <v-chip @input="deleteStateSelectionItem(item.Name)" small close v-if="index == 0">{{item.Name}}</v-chip>
                            <v-chip small v-if="index == 1">+ {{SELECTED_STATES.length - 1}} more</v-chip>
                        </template>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <chart id="womenInParliament" :chartData="chartData" />
            <br/>
            <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                <v-btn outline small slot="activator">
                    Sort <v-icon>sort</v-icon>
                </v-btn>
                <v-list>
                        <v-subheader
                        >
                        Sort by:
                        </v-subheader>
                    <v-list-tile v-for="(item, index) in headers.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                        <v-list-tile-title>
                            {{ item.text }}
                            <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                        </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-data-table
                :headers="headers" 
                :items="filteredItems"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="PAGINATION"
                :loading="loading"
                :custom-sort="customSort"
                :hide-headers="isMobile"
                :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                :disable-initial-sort="true">
                <template v-slot:items="props">
                    <template v-if="isMobile">
                        <tr>
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item">
                                        <h3><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}">{{ props.item.DisplayName }}</router-link></h3>
                                    </div>
                                    <div class="flex-item flex-item-col flex-item-col-30">
                                        <div class="flex-item">
                                            <Portrait v-bind:PHID="props.item.Phid" :fixedWidth="80"></Portrait>
                                        </div>
                                    </div>
                                    <div class="flex-item flex-item-col flex-item-col-70">
                                        <div class="flex-item" data-label="Party">
                                            <div v-for="party in props.item.PartyList" :key="party.$key" ><a @click="handlePartyClick(party.Name)">{{ party.Name }}</a></div>
                                        </div>
                                        <div class="flex-item" data-label="State">
                                            <div v-if="selectedMpOrSenator[0] === 'mp' && selectedMpOrSenator.length === 1"><div v-for="electorate in props.item.Electorate.filter((value, index, self) => index === self.findIndex(v => v.Id === value.Id))" :key="electorate.Id" >{{ electorate.Name }}</div></div>
                                            <div v-else><div v-for="state in props.item.State.filter((value, index, self) => index === self.findIndex(v => v.Id === value.Id))" :key="state.$key" ><a @click="handleStateClick(state.Id)">{{ state.Name }}</a></div></div>
                                        </div>
                                    </div>
                                    <div class="flex-item" data-label="Period of service">
                                        <div v-for="service in props.item.Service" :key="service.$key">
                                            {{ service.Text }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-if="!isMobile">
                        <td class="text-xs-left"><Portrait :PHID="props.item.Phid" :fixedWidth="80"></Portrait></td>
                        <td class="text-xs-left"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}">{{ props.item.DisplayName }}</router-link></td>
                        <td class="text-xs-left"><span v-for="(party,index) in props.item.PartyList" :key="party.$key" ><span v-if="index !== 0">, </span><a @click="handlePartyClick(party.Name)">{{ party.Name }}</a></span></td>
                        <td class="text-xs-left" v-if="selectedMpOrSenator[0] === 'mp' && selectedMpOrSenator.length === 1"><div v-for="electorate in props.item.Electorate.filter((value, index, self) => index === self.findIndex(v => v.Id === value.Id))" :key="electorate.Id" >{{ electorate.Name }}</div></td>
                        <td class="text-xs-left" v-else><div v-for="state in props.item.State.filter((value, index, self) => index === self.findIndex(v => v.Id === value.Id))" :key="state.$key" ><a @click="handleStateClick(state.Id)">{{ state.Name }}</a></div></td>
                        <td class="text-xs-left">
                            <div v-for="service in props.item.Service" :key="service.$key">
                                {{ service.Text }}
                            </div>
                        </td>
                    </template>
                </template>
                 <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>
            <br/>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>            
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import StatisticalMemberOrSenatorSelector from './StatisticalMemberOrSenatorSelector.vue';
import Chart from './Chart.vue';
import Portrait from '@/components/Portrait.vue'
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;
import CountUp from './CountUp.vue';
import _debounce from 'lodash.debounce';

export default {
    created() {
        this.initialiseItems();
    },
    components: {
        Loader,
        StatisticalHeader,
        StatisticalMemberOrSenatorSelector,
        Portrait,
        Chart,
        CountUp
    },
    mounted(){
        if (this.$route.query.s) {
            this.search = this.$route.query.s;
        }
        this.onResize();
    },
    methods: {
        initialiseItems() {
            this.loading = true;
            const parliamentarianType = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];
            const url = `StatisticalInformation/WomenInParliamentByDate?parliamentariantype=${parliamentarianType}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data.slice();
                    this.items = this.items.map(c => ({ ...c, PartyList: [...new Map(c.Party.map(item => [item['Id'], item])).values()] }));
                    this.filteredItems = response.data.slice();
                    this.totalWomenCount = response.data.length;
                    this.womenInCurrentParliament = response.data.filter(p => p.InCurrentParliament).length;
                    const allParties = response.data.slice().reduce((r, obj) => r.concat(obj.Party.map(p => p.Name)), []);
                    const distinctParties = allParties.filter((v, i, a) => a.indexOf(v) === i).sort();
                    this.PARTIES = distinctParties;
                    this.SELECTED_PARTIES = this.SELECTED_PARTIES.filter(i => this.PARTIES.indexOf(i) > -1);
                    this.loading = false;
                    this.PERFORM_SEARCH();
                });
        },
        PERFORM_SEARCH: function () {
            let query = this.$router.query || {};
            let index = 0;

            if (this.search) {
                query.s = this.search;
            }

            this.filteredItems = this.items.slice()
                .filter(i => (
                        (i.DisplayName.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                    || (i.Party.filter(e => e.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1).length > 0))
                    || (i.State.filter(e => e.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1).length > 0));

            if (this.SELECTED_STATES.length > 0) {
                if (this.filteredItems.length === 0) {
                    this.filteredItems = this.items.slice();
                }

                this.filteredItems = this.filteredItems.filter(i => i.State.filter(e => this.SELECTED_STATES.indexOf(e.Name) > -1).length > 0);
            }

            if (this.SELECTED_PARTIES.length > 0) {
                if (this.filteredItems.length === 0) {
                    this.filteredItems = this.items.slice();
                }

                this.filteredItems = this.filteredItems.filter(i => i.Party.filter(e => this.SELECTED_PARTIES.indexOf(e.Name) > -1).length > 0);
            }

            if (!this.search && this.SELECTED_PARTIES.length == 0 && this.SELECTED_STATES.length == 0) {
                this.filteredItems = this.items.slice();
            }
        },
        FILTER_STATE_OPTIONS: function (item, queryText) {
            const abbrev = item.Abbrev.toLowerCase();
            const name = item.Name.toLowerCase();
            const searchText = queryText.toLowerCase()
            return name.indexOf(searchText) > -1 || abbrev.indexOf(searchText) > -1;
        },
        currentPartyIcon: function (partyName) {
            if (this.SELECTED_PARTIES.some(p => p === partyName)) {
                return '$vuetify.icons.checkboxOn';
            } else {
                return '$vuetify.icons.checkboxOff';
            }
        },
        filterMpOrSenator() {
            this.initialiseItems();
        },
        deleteStateSelectionItem(item) {
            this.SELECTED_STATES = this.SELECTED_STATES.filter(find => find !== item);
            this.PERFORM_SEARCH();
        },
        deletePartySelectionItem(item) {
            this.SELECTED_PARTIES = this.SELECTED_PARTIES.filter(find => find !== item);
               this.PERFORM_SEARCH();
        },
        CLICK_CURRENTPARTIES: function (partyName) {
            this.$nextTick(() => {
                if (this.SELECTED_PARTIES.includes(partyName)) {
                    let index = this.SELECTED_PARTIES.indexOf(partyName);
                    if (index > -1) {
                        this.SELECTED_PARTIES.splice(index, 1);
                    }
                } else {
                    this.SELECTED_PARTIES.push(partyName);
                }
                this.FILTER_PARTIES();
            });
        },
        handlePartyClick(partyId) {
            const query = {
                "logicalOperator":"all",
                "children":[
                {
                    "type": "query-builder-rule",
                    "query": {
                    "rule": "gender",
                    "selectedOperator": "is",
                    "selectedOperand": "Gender",
                    "value": "Female"
                    }
                }]
            };
            if (partyId) {
                var partyVal = "[{\"field\":\"RefList1\",\"value\":[],\"simpleValue\":[],\"textValue\":\"" + partyId + "\",\"dateValue\":null,\"fieldType\":null}]";
                query.children.push({"type":"query-builder-rule","query":{"rule":"parties.represented.new","selectedOperator":"of","selectedOperand":"Parties represented", "value":partyVal }});
            }
            this.handleParliamentarianType(query);
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        handleStateClick(stateId) {
            const query = {
                "logicalOperator":"all",
                "children":[
                {
                    "type": "query-builder-rule",
                    "query": {
                    "rule": "gender",
                    "selectedOperator": "is",
                    "selectedOperand": "Gender",
                    "value": "Female"
                    }
                }]
            };
            if (stateId) {
                query.children.push({"type":"query-builder-rule","query":{"rule":"state","selectedOperator":"of","selectedOperand":"State","value":stateId}});
            }
            this.handleParliamentarianType(query);
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        handleParliamentarianType(query) {
            if (this.selectedMpOrSenator.length == 1) {
                const selected = this.selectedMpOrSenator[0];
                switch (selected) {
                    case 'senator':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"senator"}});
                        break;
                    case 'mp':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"member"}});
                }
            }
        },
        customSort(items, index, isDesc) {
            items.sort((a, b) => {
                if (index === "Service") {
                    // for items, get party
                    // a is less than b is -1
                    // a is greater than b is 1
                    const aService = a[index][0].Date;
                    const bService = b[index][0].Date;
                    if (!isDesc) {
                        return aService < bService ? -1 : 1;
                    } else {
                        return bService < aService ? -1 : 1;
                    }
                } else if (index === 'Party' || index === 'State') {
                    const aService = a[index][0].Name;
                    const bService = b[index][0].Name;
                    if (!isDesc) {
                        return aService < bService ? -1 : 1;
                    } else {
                        return bService < aService ? -1 : 1;
                    }
                } else {
                    if (!isDesc) {
                        return a[index] < b[index] ? -1 : 1;
                    } else {
                        return b[index] < a[index] ? -1 : 1;
                    }
                }
            });
            return items;
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items.map(i => 
                ({ 
                    Phid: i.Phid,
                    Parliamentarian: i.DisplayName, 
                    Party: i.Party.map(p => p.Name).join(', '),
                    State: i.State.map(s => s.Name).join(', '),
                    'Period of service': i.Service.map(s => s.Text).join('\n')
                }));
            let headers = this.headers.map(h => h.text);
            const filename = 'Women in Parliament (by date)';
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        },
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.PAGINATION.sortBy === column) {
                this.PAGINATION.descending = !this.PAGINATION.descending
            } 
            else {
                this.PAGINATION.sortBy = column
                this.PAGINATION.descending = false
            }
        },
    },
    computed: {
        currentParties: function () {
                let parties = [];
                if (this.$store.getters.GET_PARLIAMENTS_ORDERED && this.$store.getters.GET_PARLIAMENTS.length > 0) {
                    let pid = this.$store.getters.GET_PARLIAMENTS_ORDERED[0].PID;
                    parties = this.$store.getters.GET_PARLIAMENTS_ORDERED.find(p => p.PID === pid).PartiesByParliament;
                }
                return parties;
            },
        stateSelectLabel: function () {
                var label = 'Select a State Represented';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'State';
                }
                return label;
            },
            partySelectLabel: function () {
                var label = 'Select a Party';
                if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                    label = 'Party';
                }
                return label;
            },
            debouncedOnChange () {
                return _debounce(this.PERFORM_SEARCH, 700);
            },
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            chartData() {
                var that = this;
                let data = [];
                let categories = [];

                var min = new Date(1943,7,1).valueOf()
                var max = new Date().valueOf();

                this.filteredItems.forEach((p, pi) => {
                    p.CombinedService.forEach((d, i) => {
                        // add in item. if previous item is connected, just edit latest item
                        if (i === 0) {
                            categories.push(p.DisplayName);
                            data.push({
                                name: p.DisplayName,
                                PHID: p.Phid,
                                Party: d.Name,
                                x: new Date(d.Date).valueOf(),
                                x2: new Date(d.DateEnd).valueOf(),
                                y: pi,
                                color: d.Colour
                            });
                        }
                        else {
                            const previous = p.CombinedService[i - 1];
                            // if joined
                            if (new Date(previous.DateEnd).addDays(1) >= new Date(d.Date)
                            && previous.Name == d.Name) {
                                // join
                                data[data.length - 1].x2 = new Date(d.DateEnd).valueOf();
                            } else {
                                data.push({
                                    name: p.DisplayName,
                                    PHID: p.Phid,
                                    Party: d.Name,
                                    x: new Date(d.Date).valueOf(),
                                    x2: new Date(d.DateEnd).valueOf(),
                                    y: pi,
                                    color: d.Colour
                                });
                            }
                        }
                    });
                });

                return {
                    chart: {
                        marginLeft: this.isMobile ? 0 : 400,
                        type: 'xrange',
                        height: this.filteredItems.length < 20 ? (this.isMobile ? 300 : 500) : (this.isMobile ?  this.filteredItems.length * 6 : this.filteredItems.length * 15),
                        events: {
                            render: function() {
                                var axis = this.yAxis[0];
                                var ticks = axis.ticks;
                                var points = this.series[0].points;
                                var chart = this;
                                if (!that.isMobile){
                                    Object.keys(ticks).forEach(function(t,index) {
                                        var tick = ticks[index];
                                        if (tick){
                                            var label = tick.label.element;
                                            var point = points.find(p => p.name == tick.label.textStr);

                                            if (point){
                                                label.onclick = function() {
                                                    that.$router.push({ name: that.$store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: point.PHID }});
                                                }

                                                label.onmouseover = function() {
                                                    that.hoveredPoint = point;
                                                    that.hoveringLabel = true;
                                                    chart.tooltip.refresh(point)
                                                } 
                                                
                                                label.onmouseout = function() {
                                                    chart.tooltip.hide();
                                                    that.hoveringLabel = false;
                                                }
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            point: {
                                events: {
                                    click: function () {
                                        that.$router.push({ name: that.$store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: this.PHID }});
                                    },
                                    mouseOver: function() {
                                        that.hoveredPoint = this;
                                        that.hoveringLabel = false;
                                    },
                                    mouseOut: function() {
                                        that.hoveredPoint = null;
                                        that.hoveringLabel = false;
                                    }
                                }
                            }
                        }
                    },
                    tooltip: {
                        borderWidth: 0,
                        backgroundColor: 'transparent',
                        shadow: false,
                        enabled: this.isMobile ? false : true,
                        useHTML: true,
                        formatter: function () {
                            var todaysDate = new Date();
                            var dateIsToday = new Date(this.x2).setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0);
                            var showEndDate = dateIsToday ? 'present' : new Date(this.x2).toLocaleDateString('en-AU');

                            var tooltipMarkup = '<div class="tooltip" style="width:300px;min-height: 100px;">'
                            + '<div style="display:inline-block;"><img src="https://www.aph.gov.au/api/parliamentarian/' 
                            + this.point.PHID  
                            + '/image" style="width: 80px;border-radius: 5px;" /></div><div style="vertical-align: top;display:inline-block; width:200px; padding-left:10px;">' 
                     
                            + (!that.hoveringLabel ? 
                                ('<p style="font-size:1.1em;font-weight:bold;white-space: normal;">' + this.point.name + '</p>' 
                                + '<p style="white-space: normal; margin-bottom:0.2rem;">' + this.point.Party + '</p>'
                                + '<p style="white-space: normal; margin-bottom:0.2rem;">' + new Date(this.x).toLocaleDateString('en-AU') + ' - ' + showEndDate + '</p>')
                                : '<p style="font-size:1.1em;font-weight:bold;margin-top: 35px;white-space: normal;">' + this.point.name + '</p>' )
                            + '</div></div>';
                       
                            return tooltipMarkup ;
                        },    
                        positioner: function() {
                            var x = that.hoveredPoint.shapeArgs.x;
                            var y = that.hoveredPoint.shapeArgs.y;
                         
                            return {
                                x: that.hoveringLabel ? 380 : x + 80,
                                y: y + 40
                            }
                        },
                    },

                    legend: {
                        enabled: false
                    },

                    title: {
                        text: 'Women in Parliament over time'
                    },
                    exporting: {
                        filename: 'Women in Parliament over time',
                        sourceWidth: 2000
                    },
                    xAxis: {
                        type: 'datetime',
                        min: min,
                        max: max
                    },
                    yAxis: {
                        title: {
                            text: ''
                        },
                        type: 'category',
                        labels: {
                            enabled: this.isMobile ? false : true,
                            step: 1,
                            style: {
                                cursor: 'pointer'
                            },
                        },
                        categories,
                        reversed: true
                    },
                    series: [{
                        name: 'Parliamentary service',
                        pointWidth: this.isMobile ? 3 : 10,
                        data,
                    }]                    
                }
            },
            
    },   
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        }
    },
    data() {
        return {
        title: 'List of all women in Parliament',
        isMobile: false,
        totalWomenCount: 0,
        womenInCurrentParliament: 0,
        search: "",
        partySearchInput: '',
        stateSearchInput: '',
        SELECTED_STATES: [],
        SELECTED_PARTIES: [],
        PARTIES: this.$store.getters.GET_PARTIES,
        hoveredPoint: null,
        hoveringLabel: false,
        PAGINATION: {
            rowsPerPage: 25,
            sortBy: "",
            descending: false
        },
        headers: [
            {
                text: '',
                value: 'DisplayName' 
            },
            {
                text: 'Parliamentarian',
                value: 'DisplayName'
            },
            {
                text: 'Party',
                value: 'Party'
            },
            {
                text: 'State',
                value: 'State'
            },
            {
                text: 'Period of service',
                value: 'Service'
            }
        ],
        items: [],
        filteredItems: [],
        isOpen: false,
        loading: true,
        csvDownloading: false,
        selectedMpOrSenator: ['senator', 'mp'],
        memberOrSenator: 'member',
        rowsPerPageItems: [ 10, 25, {
            "text": "$vuetify.dataIterator.rowsPerPageAll",
            "value": -1
            }]
        }
    }
}
</script>
<style scoped>
    a {
        text-decoration: none;
    }

    
</style>
<style lang="stylus" scoped>

#womenInParliament >>> div {
    overflow: visible !important;
  }


#womenInParliament >>> .highcharts-container {
    overflow: visible !important;
  }

  #womenInParliament >>> .highcharts-container svg {
    overflow: visible !important;
  }

  #womenInParliament >>> .highcharts-tooltip span {
    background-color: transparent;
}   
  #womenInParliament >>> .highcharts-yaxis-labels text {
        cursor: pointer !important;
    }


</style>